import { Divider, Grid, Typography } from "@mui/material";
import { Fragment } from "react";
import { IconAttribute } from "../AttributeIcon/AttributeIcon";
import { HotelAttributeGroupsDto, HotelUnitGroupAttributeGroupsDto } from "../../../api/aggregation-client/service";

type Props = {
  attributes: (HotelAttributeGroupsDto & HotelUnitGroupAttributeGroupsDto)[];
};

const gridItemWidthBy: Record<"one" | "two" | "three" | "four", number> = {
  one: 12,
  two: 6,
  three: 4,
  four: 3,
};

export const UnitGroupAttributes = (props: Props) => {
  const { attributes } = props;

  return (
    <>
      {attributes
        .filter((a) => a.attributes?.length > 0)
        .map((attrGroup) => {
          return (
            <Fragment key={attrGroup.title}>
              <Divider sx={{ marginTop: 4, marginBottom: 2 }} />
              <Typography variant={"h6"} sx={{ marginBottom: 2 }}>
                {attrGroup.title_single_page || attrGroup.title}
              </Typography>
              <Grid container spacing={2}>
                {attrGroup.attributes.map((attr) => (
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  <Grid key={attr.id} item xs={12} md={gridItemWidthBy[attrGroup?.maxItemsPerRow || "one"]}>
                    <Typography variant={"body2"} sx={{ marginBottom: 2 }}>
                      <IconAttribute attribute={attr} size={32} />
                      <span data-testid={`filter-${attr.code}`}>{attr.title}</span>
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Fragment>
          );
        })}
    </>
  );
};
